import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { detectDeviceInfo } from '@/utils/deviceDetection';

export const useInitTracking = () => {
  useEffect(() => {
    // Checar se já foi executado nesta sessão
    const hasInit = sessionStorage.getItem('app_init');
    if (hasInit) {
      console.log('[Init] Already initialized in this session');
      return;
    }
    
    // Delay de 2s para não impactar carregamento inicial
    const timer = setTimeout(async () => {
      try {
        // Capturar device info
        const deviceInfo = detectDeviceInfo();
        
        // Capturar UTMs da URL
        const params = new URLSearchParams(window.location.search);
        
        // Chamar edge function 'init' (nome genérico)
        const { error } = await supabase.functions.invoke('init', {
          body: {
            referrer_url: document.referrer || null,
            landing_page: window.location.href,
            utm_source: params.get('utm_source') || null,
            utm_medium: params.get('utm_medium') || null,
            utm_campaign: params.get('utm_campaign') || null,
            utm_term: params.get('utm_term') || null,
            utm_content: params.get('utm_content') || null,
            gad_campaignid: params.get('gad_campaignid') || null,
            browser_name: deviceInfo.browserName,
            browser_version: deviceInfo.browserVersion,
            device_type: deviceInfo.deviceType,
            operating_system: deviceInfo.operatingSystem,
            device_language: navigator.language,
            user_agent: deviceInfo.userAgent,
          }
        });
        
        if (error) {
          console.error('[Init] Error:', error);
        } else {
          console.log('[Init] Completed successfully');
        }
        
        // Marcar como inicializado
        sessionStorage.setItem('app_init', 'true');
        
      } catch (error) {
        console.error('[Init] Exception:', error);
      }
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);
};
